import { Stack, styled as muiStyled } from '@mui/material';

export const IconContainer = muiStyled(Stack)(() => ({
  backgroundColor: '#D1D8E0',
  cursor: 'pointer',
  borderRadius: '50%',
  padding: '4px',
}));
